// 📂 pages/Client/ClientProfileModulesPage.tsx
import { useEffect } from 'react';
import { Column } from 'react-table';

import ClientProfileModulesTable from '../../components/Client/Table/ClientProfileModulesTable';
import ModuleDetailPanel from '../../components/Client/Table/ModuleDetailPanel/ModuleDetailPanel';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import { useModule } from '../../hooks/module/useModule';

const ClientProfileModulesPage = () => {
  const { modules, fetchModules } = useModule();

  useEffect(() => {
    fetchModules();
  }, []);

  const columns: Column<any>[] = [{ Header: 'Módulo', accessor: 'name' }];

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <ClientProfileModulesTable
        modules={modules.map((m) => ({ id: m.id, name: m.name }))}
        columns={columns}
        enableRowClick
        getExpandedComponent={() => <ModuleDetailPanel />}
      />
    </DefaultLayout>
  );
};

export default ClientProfileModulesPage;
